import React from 'react';

import { i18n } from 'app/i18n';
import { Typography } from 'app/components/domain/typography';
import { CustomerInformation } from 'app/page/orders/model/customer-information';
import { AddressMapper } from 'app/page/orders/mapper/address-mapper';
import { BaseImageProps, Image } from 'app/components/common/image';
import userIcon from 'app/resources/user-bold.svg';
import mapPinIcon from 'app/resources/map-pin.svg';
import calendarIcon from 'app/resources/calendar.svg';
import phoneIcon from 'app/resources/phone.svg';
import mailIcon from 'app/resources/mail.svg';
import { Card } from 'app/components/domain/card/card';

import styles from './customer-details.module.scss';

interface Props {
    order: OrderTrackerBackend.Order;
    customerInformation: CustomerInformation;
}

class CustomerDetails extends React.Component<Props> {
    private readonly renderCustomerDetails = (): React.ReactNode => {
        const { order, customerInformation } = this.props;

        const { fullName, birthDate, email, phoneCountryCode, phoneNumber } = customerInformation;

        return (
            <>
                {this.renderCustomerDetailsRow(fullName, { src: userIcon, alt: i18n.image.user })}
                {this.renderCustomerDetailsRow(birthDate.replace(/-/g, '.'), {
                    src: calendarIcon,
                    alt: i18n.image.calendar,
                })}
                {this.renderCustomerDetailsRow(email, { src: mailIcon, alt: i18n.image.mail })}
                {this.renderCustomerDetailsRow(`(${phoneCountryCode}) ${phoneNumber}`, {
                    src: phoneIcon,
                    alt: i18n.image.phone,
                })}
                {this.renderCustomerDetailsRow(AddressMapper.toDisplayAddress(order.deliveryServiceAddress!), {
                    src: mapPinIcon,
                    alt: i18n.image.mapPin,
                })}
            </>
        );
    };

    private readonly renderCustomerDetailsRow = (value: string, image: BaseImageProps): React.ReactNode => (
        <div className={styles.container}>
            <Image className={styles.image} {...image} />
            <Typography variant="body1" component="p">
                {value}
            </Typography>
        </div>
    );

    public render(): React.ReactNode {
        return (
            <Card>
                <Typography className={styles.title} variant="subtitle3" component="p">
                    {i18n.summary.customerDetails.title}
                </Typography>
                {this.renderCustomerDetails()}
            </Card>
        );
    }
}

export { CustomerDetails };
